<div class="acadmics">
  <div class="dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <button type="button" class="cmn-button fw-600 mt-0 py-0 dropdown-toggle" id="dropdownMenuButton"
      data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-haspopup="true">
      Programs
    </button>

    <div class="dropdown-menu menus scroll-sec" aria-labelledby="dropdownMenuClickableInside">
      <div class="sec-thirdtitle mb-3  ms-3 mt-3">
        <h5 class="fw-bold">Programs Offered</h5>
      </div>
      <ul class="academics-list right-borderd">
        <li>
          <a type="button" class="accordion aca-drop" [class.active]="activeTab === 'ug'"
            [attr.aria-expanded]="activeTab === 'ug'" aria-controls="ug-panel" (click)="onTabClick('ug')">
            Under Graduate Programs
          </a>
          <!-- <a href="javascript:void(0)" class="accordion aca-drop" [class.active]="activeTab === 'ug'"
            (click)="onTabClick('ug')">
            Under Graduate Programs
          </a> -->

          <div id="ug-panel" *ngIf="activeTab === 'ug'" class="accordion-collapse" [class.show]="activeTab === 'ug'">
            <div class="accordion-body scroll-box">
              <div class="row row-cols-2 g-3 g-md-4">
                <ng-container *ngTemplateOutlet="cardsTpl; context: { programs: ugPrograms }"></ng-container>
              </div>
            </div>
          </div>
        </li>
        <li>

          <a type="button" class="accordion aca-drop" [class.active]="activeTab === 'pg'"
            [attr.aria-expanded]="activeTab === 'pg'" aria-controls="pg-panel" (click)="onTabClick('pg')">
            Post Graduate Programs
          </a>
          <!-- <a href="javascript:void(0)" class="accordion aca-drop" [class.active]="activeTab === 'pg'"
            (click)="onTabClick('pg')">
            Post Graduate Programs
          </a> -->
          <div id="pg-panel" *ngIf="activeTab === 'pg'" class="accordion-collapse" [class.show]="activeTab === 'pg'">
            <div class="accordion-body scroll-box">
              <div class="row row-cols-2 g-2 g-md-4">
                <ng-container *ngTemplateOutlet="cardsTpl; context: { programs: pgPrograms }"></ng-container>
              </div>
            </div>
          </div>
        </li>
        <li>

          <a type="button" class="accordion aca-drop" [class.active]="activeTab === 'pgd'"
            [attr.aria-expanded]="activeTab === 'pgd'" aria-controls="pgd-panel" (click)="onTabClick('pgd')">
            Post Graduate Diploma
          </a>
          <!-- <a href="javascript:void(0)" class="accordion aca-drop" [class.active]="activeTab === 'pgd'"
            (click)="onTabClick('pgd')">
            Post Graduate Diploma
          </a> -->
          <div id="pgd-panel" *ngIf="activeTab === 'pgd'" class="accordion-collapse" [class.show]="activeTab === 'pgd'">

            <div class="accordion-body scroll-box">
              <div class="row row-cols-2 g-2 g-md-4">
                <ng-container *ngTemplateOutlet="cardsTpl; context: { programs: pgdPrograms }"></ng-container>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #cardsTpl let-programs="programs">
  <div class="col" *ngFor="let p of programs">
    <div class="program-card" [class.share-active]="p.shareOpen">
      <div class="program-details">
        <div class="d-flex align-items-start justify-content-between">
          <div class="sec-thirdtitle w-auto text-start">
            <h5 class=" text-dark">{{ p.title }}</h5>
          </div>
          <app-program-share [title]="p.title" [url]="shareUrl(p)"
            (openChange)="p.shareOpen = $event"></app-program-share>
        </div>
        <div class="d-flex justify-content-between">
          <div class="pro-year">
            <i class="material-symbols-outlined">calendar_month</i>
            <span>{{ p.years }} Years</span>
            <i class="material-symbols-outlined ms-3">schedule</i>
            <span>Full Time</span>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <a *ngIf="p.routerLink" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="p.routerLink" class="cmn-white-button" [attr.aria-label]="'Learn more about ' + p.title">
            Learn More<span class="visually-hidden"> about {{ p.title }}</span>
          </a>
          <a *ngIf="!p.routerLink" [href]="p.href" [target]="p.learnMoreTarget || null"
            [attr.rel]="p.learnMoreTarget === '_blank' ? 'noopener noreferrer' : null" class="cmn-white-button"
            [attr.aria-label]="'Learn more about ' + p.title">
            Learn More<span class="visually-hidden"> about {{ p.title }}</span>
          </a>
          <a [href]="p.applyHref" target="_blank" rel="noopener noreferrer" class="cmn-button text-white"
            [attr.aria-label]="'Apply now for ' + p.title">
            Apply Now
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
